module.exports = function getResource(label, vars = []) {
    let resources = {
        automaticUpdate: 'Choisir une date actualisera automatiquement les magasins et les plages horaires affichés.',
        chooseDate: 'Sélectionner une date',
        seeMoreDates: 'Voir plus de dates'
    };

    return resources[label];
};
